var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthStore } from '../application/stores/auth.store';
import { useCompanyStore } from '../application/stores/company.store';
import Loader from '../components/common/Loaders/Loader';
import { useNavigate } from 'react-router-dom';
export const ProtectedRoute = () => {
    const { isAuthReady, setClientToken } = useAuthStore();
    const { isCompanyReady, company } = useCompanyStore();
    const navigate = useNavigate();
    useEffect(() => {
        const redirectToPaymentIfNeeded = () => __awaiter(void 0, void 0, void 0, function* () {
            if (company && !company.isPaid) {
                yield setClientToken();
                window.location.href = `/payments/${company.companyId}`;
                //TODO por que no usar navigate?
                //navigate(`/payments/${company.companyId}`);
            }
        });
        redirectToPaymentIfNeeded();
    }, [company]);
    if (!isAuthReady || !isCompanyReady) {
        return _jsx(Loader, { fullBlack: true });
    }
    if (!company.isPaid) {
        return null;
    }
    return _jsx(Outlet, {});
};
